import { render, staticRenderFns } from "./BarOrders.vue?vue&type=template&id=326c6d7b&"
import script from "./BarOrders.vue?vue&type=script&lang=ts&"
export * from "./BarOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports